import {useRef, useState} from 'react';

export const useAdornmentWidth = (): [number, (el: HTMLDivElement | null) => void] => {
    const [adornmentWidth, setAdornmentWidth] = useState<number>(0);
    const observerRef = useRef<ResizeObserver | null>(null);

    const adornmentRef = (el: HTMLDivElement | null) => {
        if (!el) {
            observerRef.current?.disconnect();
            observerRef.current = null;
            setAdornmentWidth(0);
            return;
        }

        if (el.offsetWidth) {
            setAdornmentWidth(el.offsetWidth + 8);
        }

        observerRef.current = new ResizeObserver(() => {
            setAdornmentWidth(el.offsetWidth ? el.offsetWidth + 8 : 0);
        });
        observerRef.current.observe(el);
    };

    return [adornmentWidth, adornmentRef];
};
